/** Total steps in the coachmark tour (Pin → Hover → Create → PinPersist) */
export const TOTAL_STEPS = 4;

/** Time for the Radix spotlight exit animation (fade-out + zoom-out) to complete */
export const SPOTLIGHT_FADE_OUT_MS = 200;

/** Time for the sidebar panel to settle after expanding (floating → inline) */
export const PANEL_EXPAND_SETTLE_MS = 200;

/** Time for the sidebar panel to settle after collapsing (inline → floating) */
export const PANEL_COLLAPSE_SETTLE_MS = 500;
